export interface ArtworkListMapperI {
  select: boolean;
  id: string;
  thumbnail: string;
  task: string;
  designNo: string;
  identity: string;
  customerName: string;
  designTypeName: string;
  category: string;
  estimated: string;
  dueDate: string;
  createdDate: string;
  priority: string;
  statusName:string;
  assignee: string;
  projectName: string;
  dateApproved: string;
  approvedBy: string;
  orderNum: string;
  orderIdentity: string;
  artworkContactName: string;
  artworkContactEmail: string;
  royaltyRetail: string;
  royaltyRetailAmountType: string;
  royaltyWholesale: string;
  royaltyWholesaleAmountType: string;
  pinned: string;
  salesRep: string;
  salesManagerName: string;
  productionManagerName: string;
  csrName: string;
  alternateAccountNumber: string;
  artworkLocation: string;
}
